import {$experiments} from '@commercial-website/analytics'
import {useStore} from '@nanostores/react'

/**
 * Returns the regex source for every running page-split experiment, read reactively from
 * the experiments store. Empty until experiments load; re-renders when they arrive so
 * LocalizedLink can switch matching links to a hard navigation.
 */
export const usePageSplitExperimentPaths = (): string[] => {
    const {paths} = useStore($experiments)
    return paths
}
